module.exports = "/_next/static/images/Viktor_Pilgun-ece295ca647f4f73a53fcde617bff155.webp";